import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";
import { resolveTranslationUsername, translationErrorMessage } from "./translationRequest";

const TERMINALI = ["SUCCESS", "PARTIAL_SUCCESS", "ERROR"];
const ETICHETTE = { PENDING: "In coda", RUNNING: "In corso", SUCCESS: "Completata", PARTIAL_SUCCESS: "Completata con errori", ERROR: "Fallita" };

export default function VerificaTraduzioniOnline({ utente, selection, eligibleCount, disabled, onComplete }) {
  const { getAccessTokenSilently } = useAuth0();
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  const mounted = useRef(false);
  const canRun = Boolean(utente?.permessiAPI?.["update:prestashop"]);
  const active = job && !TERMINALI.includes(job.status);

  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const jobId = job?.jobId;
  const status = job?.status;
  useEffect(() => {
    if (!jobId || TERMINALI.includes(status)) return undefined;
    const controller = new AbortController();
    let timer;
    async function poll() {
      try {
        const token = await getAccessTokenSilently();
        if (controller.signal.aborted) return;
        const response = await axios.get(`${apiUrl}/prodotti/translate/verifiche/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
        });
        if (controller.signal.aborted) return;
        const next = response.data?.job;
        if (!response.data?.success || !next || next.jobId !== jobId) throw new Error("Stato verifica non disponibile.");
        setJob(next);
        setError("");
        if (TERMINALI.includes(next.status)) { onComplete(); return; }
      } catch (err) {
        if (controller.signal.aborted) return;
        setError(translationErrorMessage(err));
      }
      timer = setTimeout(poll, 3000);
    }
    poll();
    return () => { controller.abort(); clearTimeout(timer); };
  }, [jobId, status, getAccessTokenSilently, onComplete]);

  async function avvia() {
    if (pending.current || active || disabled || !canRun || !eligibleCount) return;
    if (!window.confirm(`Verificare i testi online VIG e BOT per ${eligibleCount} articoli eleggibili della selezione applicata?`)) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      const token = await getAccessTokenSilently();
      const username = await resolveTranslationUsername({ username: utente?.username,
        email: utente?.email, accessToken: token });
      const response = await axios.post(`${apiUrl}/moda/articoli/bulk-jobs`, {
        jobType: "verifica_traduzioni_online", filters: selection, expectedEligible: eligibleCount, username,
      }, { headers: { Authorization: `Bearer ${token}`, "X-Domino-Username": username } });
      if (!response.data?.success || !response.data.job?.jobId) throw new Error("Verifica non accodata.");
      if (mounted.current) {
        setJob(response.data.job);
        if (TERMINALI.includes(response.data.job.status)) onComplete();
      }
    } catch (err) {
      if (mounted.current) setError(translationErrorMessage(err));
    } finally {
      pending.current = false;
      if (mounted.current) setBusy(false);
    }
  }

  if (!canRun) return null;
  return <div className="mt3 mb3" aria-label="Verifica traduzioni online">
    <button className={stilePulsanti.buttonClassesWhite} onClick={avvia}
      disabled={disabled || busy || active || !eligibleCount}>
      {busy ? "Accodamento verifica…" : "Verifica online la selezione"}
    </button>
    <p className="f6">Legge i testi VIG e BOT degli articoli eleggibili, uno alla volta, e aggiorna la copertura.</p>
    {job && <div role="status" aria-live="polite">
      Verifica: {ETICHETTE[job.status] || job.status} · {job.processedCount}/{job.totalItems} articoli · {job.errorCount} errori
      {job.message && <div className="f6 mt1">{job.message}</div>}
      {job.recentErrors?.length > 0 && <ul>{job.recentErrors.map((row) => <li key={row.codVS}>{row.codVS}: {row.message}</li>)}</ul>}
    </div>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
